import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { Globals, Ref } from '../globals';
import { FirestoreService } from './firestore/firestore.service';

export interface FsAuto{
  id?: string;
  active?: boolean;
  color: string;
  model: string;
  placa: string;
  year: string;
  insuranceCompany: string;
  polizaNumber: string;
  datePolizaEnd: string;
}

@Injectable()
export class AutoService implements OnDestroy {

  col: string = Globals.AUTO_COLLECTION;

  constructor(
    private fsService: FirestoreService,
  ) { }
  ngOnDestroy(){
    this.autoSub && this.autoSub.unsubscribe();
  }

  _autos: BehaviorSubject<FsAuto[]>;
  autoSub?: Subscription;
  async getAutos(): Promise<FsAuto[]>{
    if(!this._autos){
      this._autos = new BehaviorSubject([]);
      await new Promise<void>(res => {
        this.autoSub = this.fsService.colWithIds$(this.col).subscribe(autos => {
          this._autos.next(autos);
          res();
        });
      });
    }
    return this._autos.value;
  }
  getAutos$(): Observable<FsAuto[]> {
    return this.fsService.colWithIds$(this.col, ref => ref.where('active', '==', true));
  }
  
  async touchAuto(auto: FsAuto): Promise<Ref | null>{
    try{
      let result = await this.fsService.addPromise(this.col, auto);
      return result;
    }catch(error){
      console.log('auto.service.touchAuto()', error);
      return null;
    }
  }

  async updateAuto(id: string, auto: Partial<FsAuto>): Promise<boolean>{
    try{
      await this.fsService.update(`${this.col}/${id}`, auto);
      return true;
    }catch(error){
      console.log('auto.service.updateAuto()', error);
      return false;
    }
  }
}
